'use client';

import { useCart } from '@/components/cart/useCart';
import { useStores } from '@/components/store/useStores';
import { StoreListing } from '@/components/store-listing';
import { PageHeader } from '@/components/layout/PageHeader';

export function StoreListingClient() {
  const { cart } = useCart();
  const { stores } = useStores();

  return (
    <>
      <PageHeader />
      <StoreListing cart={cart.data} stores={stores.data} />
    </>
  );
}
